import { GearInstance, StepperStep } from 'types';

export const getScheduledPublicationStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
): StepperStep => ({
  stepName: 'Scheduled Publication',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Publish',
    cancelCaption: 'Save To Draft',
    withFooter: true,
    buttonsShape: 'slimy',
    alignButtons: 'alignRight',
    marginMode: 'low',
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'step_title',
        value: 'Schedule Publication',
      },
      {
        type: 'description',
        fieldName: 'step_description',
        value:
          'Feel like collecting some offers? Or letting your friends on social get a first look before your Gear goes? Set the timer and users will be able see your item but not buy it, you can pick an offer you like later.',
      },
      {
        type: 'schedulePublicationBlock',
        fieldName: 'posted_at',
        value: instance,
      },
    ],
  },
});
